var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"v-stack gap-3 h-stretch v-start panel-content-left"},[_c('div',{staticClass:"panel-right v-stack v-start h-stretch"},[_c('a',{staticClass:"heading-title-1"},[_vm._v(_vm._s(_vm.date.format("DD. MM. YYYY")))]),_c('a',{staticClass:"heading-title-1",staticStyle:{"padding-top":"0px"}},[_vm._v(_vm._s(_vm.date.format("dddd")))]),_c('Calendar',{ref:"calendar",attrs:{"dayonly":true}})],1),(_vm.$store.state.accessLevel > 9)?[_c('a',{staticClass:"heading-title-1"},[_vm._v("Unsigned")]),(_vm.unsignedVacations.length != 0)?[_c('a',{staticClass:"heading-title-2"},[_vm._v("Vacations")]),_c('TableVacations',{attrs:{"vacations":_vm.unsignedVacations},on:{"refresh":function($event){return _vm.refreshUnsignedVacations()}}})]:_vm._e(),(_vm.unsignedLoans.length != 0)?[_c('a',{staticClass:"heading-title-2"},[_vm._v("Company Loans")]),_c('TableLoans',{attrs:{"loans":_vm.unsignedLoans},on:{"refresh":function($event){return _vm.refreshUnsignedLoans()}}})]:_vm._e(),(_vm.unsignedWorkdays.length != 0)?[_c('a',{staticClass:"heading-title-2"},[_vm._v("Workdays")]),_c('TableWorkdays',{attrs:{"showName":true,"workdays":_vm.unsignedWorkdays,"emptyMessage":"Everything is signed","allowSign":true},on:{"refresh":function($event){return _vm.refreshUnsignedWorkdays()}}})]:_vm._e(),(_vm.unsignedBonus.length != 0)?[_c('a',{staticClass:"heading-title-2"},[_vm._v("Bonus")]),_c('TableOneTimePay',{attrs:{"showName":true,"oneTimePay":_vm.unsignedBonus,"allowSign":true,"emptyMessage":"Everything is signed"},on:{"refresh":function($event){return _vm.refreshUnsignedBonus()}}})]:_vm._e(),(_vm.unsignedAdvance.length != 0)?[_c('a',{staticClass:"heading-title-2"},[_vm._v("Advance")]),_c('TableOneTimePay',{attrs:{"showName":true,"oneTimePay":_vm.unsignedAdvance,"allowSign":true,"emptyMessage":"Everything is signed"},on:{"refresh":function($event){return _vm.refreshUnsignedAdvance()}}})]:_vm._e(),(_vm.unsignedCount == 0)?_c('div',{staticClass:"block"},[_vm._v("Nothing to sign")]):_vm._e()]:_vm._e(),_c('a',{staticClass:"heading-title-1"},[_vm._v("Projects")]),_c('a',{staticClass:"heading-title-2"},[_vm._v("Assigned")]),_c('Table',{attrs:{"items":_vm.assignedProjects,"defaultColumn":0,"limit":5,"expandable":true,"css":"120px 80px 60px 1fr 1fr","columns":[
      {
        name: 'Project Created',
        sort: 'date',
        path: ['createdDate'],
        formatType: 'date',
        format: 'DD.MM.YYYY',
      },
      {
        name: 'Deadline',
        sort: 'date',
        path: ['deadline'],
        formatType: 'date',
        format: 'DD.MM.YYYY',
      },
      {
        name: 'Icon',
        sort: 'alphabet',
        path: ['icon'],
      },
      {
        name: 'Project',
        sort: 'alphabet',
        path: ['name'],
      },
      {
        name: 'Role',
        path: ['roles'],
        formatType: 'array',
      },
    ]},on:{"rowSelected":function($event){return _vm.$router.push('/projects/detail/' + $event.project._id)}}}),_c('a',{staticClass:"heading-title-2"},[_vm._v("Shooting")]),_c('Table',{attrs:{"items":_vm.recordingDays,"defaultColumn":0,"limit":5,"expandable":true,"defaultAscending":false,"css":"80px 60px 60px 60px 2fr 1fr 1fr","columns":[
      {
        name: 'Date',
        sort: 'date',
        path: ['startDate'],
        formatType: 'date',
        format: 'DD.MM.YYYY',
      },
      {
        name: 'From',
        sort: 'date',
        path: ['startDate'],
        formatType: 'date',
        format: 'HH:mm',
      },
      {
        name: 'To',
        sort: 'date',
        path: ['endDate'],
        formatType: 'date',
        format: 'HH:mm',
      },
      {
        name: 'Icon',
        sort: 'alphabet',
        path: ['project', 'icon'],
      },
      {
        name: 'Project',
        sort: 'alphabet',
        path: ['project', 'name'],
      },
      {
        name: 'Address',
        sort: 'alphabet',
        path: ['address'],
      },
    ]},on:{"rowSelected":function($event){return _vm.$router.push('/productiondays/' + $event._id)}}}),_c('a',{staticClass:"heading-title-2"},[_vm._v("Deadlines")]),_c('Table',{attrs:{"items":_vm.deadlineProjects,"defaultColumn":1,"limit":5,"expandable":true,"defaultAscending":false,"css":"60px 80px 60px 1fr 1fr","columns":[
      {
        name: 'State',
        sort: 'alphabet',
        path: ['state'],
      },
      {
        name: 'Deadline',
        sort: 'date',
        path: ['deadline'],
        formatType: 'date',
        format: 'DD.MM.YYYY',
      },
      {
        name: 'Icon',
        sort: 'alphabet',
        path: ['icon'],
      },
      {
        name: 'Project',
        sort: 'alphabet',
        path: ['name'],
      },
    ]},on:{"rowSelected":function($event){return _vm.$router.push('/projects/detail/' + $event._id)}}})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }